import { useEffect } from "react";

function AlertHome({ show, message, type, onClose, style }) {

    useEffect(() => {
        if (show) {
            const timer = setTimeout(onClose, 3000);
            return () => clearTimeout(timer);
        }
    }, [show, onClose]);

    if (!show) return null;

    return (
        <div className="toast-container position-fixed top-0 end-0 p-3" style={style}>
            <div className={`toast show text-white bg-${type}`}>
                <div className="d-flex">
                    <div className="toast-body">{message}</div>
                    <button
                        className="btn-close btn-close-white me-2 m-auto"
                        onClick={onClose}
                    ></button>
                </div>
            </div>
        </div>
    );
}

export default AlertHome;